import { Injectable } from 'angular-ts-decorators';

/**
 * The only reason this is used is to give the hamburger
 * item in the top/bottom bar access to the side bar
 * controller in order to open/close it.
 * This is a hack and should be replaced with an
 * implementation of
 * http://help.softwear.nl/display/SWUI/Common+UI+elements+Proposal
 */
@Injectable('sidebarManager')
export class SidebarManager {
  private $ctrl: any;

  /**
   * Toggle the sidebar if it exists
   * @returns {boolean} returns true when toggled and false when not registered
   */
  toggle(): Boolean {
    return this.exists()
      ? Boolean(this.$ctrl.element.toggleClass('open'))
      : false;
  }

  /**
   * Close the sidebar if it exists
   * @returns {boolean} returns true when closed and false when not registered
   */
  close(): Boolean {
    return this.exists()
      ? Boolean(this.$ctrl.element.removeClass('open'))
      : false;
  }

  /**
   * Register the scope that contains the sidebar
   * @param {scope} $ctrl existing scope that contains the sidebar element
   * @returns {void}
   */
  register($ctrl): void {
    this.$ctrl = $ctrl;
  }

  /**
   * Checks if the sidebar exists on the registered controll
   * @returns {boolean} returns true when registered and false when not registered
   */
  exists(): boolean {
    return !!this.$ctrl && !!this.$ctrl.element;
  }
}
